import React, { useEffect} from "react";

export default function ProvinceSelect({
  value,
  name,
  provinces,
  onChange,
  label = null,
  error = null
}) {

  let style = "";

  const hasError = error && error.error === true;

  if (hasError) {
    style = "gc__input_field_error";
  }

  const labelMarkup = ( label ) ? <label className={"gc__input_label"}>{label}</label> : null;

  const errorMarkup = hasError && <p className={"gc__input_field_error_message"}>{ error.message }</p>

  return ((provinces && provinces.length) ?
    <>
      <div className={"gc__input_container"}>
        {labelMarkup}
        <select
          className={`gc__input_field ${style}`}
          name={name}
          value={value}
          onChange={e => onChange(e)}
        >
          {provinces.map((province) =>
            <option key={province[0]} value={province[0]}>
              {province[1]}
            </option>
          )}
        </select>
      </div>
      { errorMarkup }
    </>
  : null);
};
